import { RadioPanel, RadioPanelItem } from "@shared/EDS/components/RadioPanel/RadioPanel";
import { DateTime } from "luxon";
import { generateDateArray, getMinMaxDateTimes } from "../utils/luxonHelpers";
import { useCallback, useEffect, useState } from "react";

function getDates(dateTimes: DateTime[]): DateTime[] {
  if (dateTimes.length === 0) {
    return [];
  }
  const { min, max } = getMinMaxDateTimes(dateTimes);
  return generateDateArray(min, max);
}

function capitalizeFirstLetter(input: string): string {
  if (input.length === 0) {
    return input;
  }
  return input.charAt(0).toUpperCase() + input.slice(1);
}

export interface DateRadioPanelProps {
  readonly dateTimes: DateTime[];
  readonly onChange: (newDate: DateTime | undefined) => void;
}
export function DateRadioPanel({ dateTimes, onChange }: DateRadioPanelProps) {
  const [dates, setDates] = useState<RadioPanelItem[]>([]);
  useEffect(() => {
    setDates([
      { label: "Alle", value: "all" },
      ...getDates(dateTimes).map((date) => ({
        label: capitalizeFirstLetter(date.toFormat("ccc")),
        value: date.toString(),
      })),
    ]);
  }, [dateTimes]);
  const handleChangeDate = useCallback(
    (newDateString: string) =>
      onChange(newDateString === "all" ? undefined : DateTime.fromISO(newDateString)),
    [onChange],
  );

  return <RadioPanel items={dates} onChange={handleChangeDate} defaultValue="all" />;
}
